import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

// إعداد Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// دوال API
export const verifyEmail = (user_id, code) => {
  const url = `email/verification?api_password=${encodeURIComponent(API_PASSWORD)}`;
  const body = new URLSearchParams();
  body.append("code", code);
  body.append("user_id", user_id);

  return api.post(url, body, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// استدعاء إرسال الكود باستخدام query params (كما في screenshot)
export const resendCode = (email) =>
  api.post(`resend/code?email=${encodeURIComponent(email)}&api_password=${encodeURIComponent(API_PASSWORD)}`);

export const login = (email, password) =>
  api.post("login", {
    email,
    password,
    api_password: API_PASSWORD, // ✅ استدعاء من config
  });

// export const register = (data) =>
//   api.post("register", { ...data, api_password: API_PASSWORD }); // لو مطلوب
export const register = async (data) => {
  const formData = new URLSearchParams();
  formData.append("name", data.name || "");
  formData.append("email", data.email || "");
  formData.append("phone", data.phone || "");
  formData.append("password", data.password || "");

  // إرسال note دائماً (حتى لو كان فارغاً) لأن الـ API يتوقعه
  formData.append("note", data.note?.trim() || "");

  // إرسال user_broker_code دائماً (حتى لو كان فارغاً) لأن الـ API يتوقعه
  formData.append("user_broker_code", data.user_broker_code?.trim() || "");

  formData.append("api_password", API_PASSWORD);

  console.log("Sending registration data:", Object.fromEntries(formData)); // للتصحيح

  return api.post("register", formData, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};


export const getPlans = () =>
  api.get(`get/planes?api_password=${API_PASSWORD}`); // ✅ برضه من config

export default api;
